module.exports = __webpack_public_path__ + "img/icon_account_grey.4983d8ea.svg";